import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useQueryClient } from '@tanstack/vue-query'
import { useUserStore } from '@/stores/userStore'
import router from '@/router'
import { useApiMutation } from '@/composables/useApiMutation'
import { LOGOUT } from '@/services/apiModules'

interface LoginPayload {
  userID: string | null
  email: string | null
}

export const useAuthStore = defineStore('auth', () => {
  const userStore = useUserStore()
  const queryClient = useQueryClient()
  const isLoggedIn = ref(false)

  function login({ userID: userIDData, email: emailData = null }: LoginPayload): void {
    console.log('Pinia Login')
    isLoggedIn.value = true
    userStore.registerUser({
      userID: userIDData,
      email: emailData,
    })
  }

  function piniaLogout(): void {
    console.log('Pinia Logout')
    // Remove all queries from the cache, the new user might be different.
    queryClient.removeQueries()
    isLoggedIn.value = false
    userStore.removeUser()
    router.push({ name: 'login' })
  }

  const { mutateAsync } = useApiMutation({
    modus: LOGOUT,
  })

  async function logout(): Promise<void> {
    piniaLogout()

    try {
      const data = await mutateAsync({})

      if (data) {
        console.log('Logged out :', data)
      } else {
        console.error('Error during log out')
      }
    } catch (error) {
      console.error('Error Logging out: ', error)
    }
  }

  return {
    isLoggedIn,
    login,
    logout,
    piniaLogout,
  }
})
